(function () {
  const enableAutoplay =
    typeof window.enableAutoplay !== "undefined"
      ? window.enableAutoplay
      : false;

  class ProductGallery {
    constructor(container) {
      this.container = container;
      this.mainImages = Array.from(
        container.querySelectorAll(".shop-main-image")
      );
      this.thumbnails = Array.from(
        container.querySelectorAll(".shop-thumbnail")
      );
      this.dots = Array.from(container.querySelectorAll(".shop-dot"));

      this.desktopPrevArrow = container.querySelector(
        ".shop-desktop-prev-arrow"
      );
      this.desktopNextArrow = container.querySelector(
        ".shop-desktop-next-arrow"
      );
      this.mobilePrevArrows = Array.from(
        container.querySelectorAll(".shop-mobile-prev-arrow")
      );
      this.mobileNextArrows = Array.from(
        container.querySelectorAll(".shop-mobile-next-arrow")
      );

      this.indicatorsContainer = container.querySelector(
        ".shop-indicators, #thumbnail-indicators"
      );

      this.currentIndex = 0;
      this.maxIndex = this.mainImages.length - 1;
      this.init();
    }

    init() {
      this.mainImages.forEach((img, i) => {
        img.classList.toggle("active", i === 0);
      });
      this.thumbnails.forEach((thumb, i) => {
        thumb.classList.toggle("active", i === 0);
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle("active", i === 0);
      });

      this.createIndicators();
      this.attachEvents();
      this.handleVideoAutoplay(0);
      this.attachSwipeEvents();
    }

    attachSwipeEvents() {
      const surface = this.container.querySelector(
        ".shop-main-image-wrapper"
      );

      if (!surface || this.mainImages.length < 2) return;

      surface.style.touchAction = "pan-y pinch-zoom";

      let gesture = null;

      surface.addEventListener("dragstart", (event) => {
        if (event.target.closest("img")) {
          event.preventDefault();
        }
      });

      surface.addEventListener("pointerdown", (event) => {
        if (
          !event.isPrimary ||
          event.button !== 0 ||
          event.target.closest("button, a, input, video, iframe")
        ) {
          return;
        }

        gesture = {
          id: event.pointerId,
          x: event.clientX,
          y: event.clientY
        };

        surface.setPointerCapture(event.pointerId);
      });

      surface.addEventListener("pointerup", (event) => {
        if (!gesture || gesture.id !== event.pointerId) return;

        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;

        gesture = null;

        if (surface.hasPointerCapture(event.pointerId)) {
          surface.releasePointerCapture(event.pointerId);
        }

        if (
          Math.abs(dx) < 35 ||
          Math.abs(dx) <= Math.abs(dy) * 1.2
        ) {
          return;
        }

        const direction = dx < 0 ? 1 : -1;
        const nextIndex =
          (this.currentIndex + direction + this.mainImages.length) %
          this.mainImages.length;

        this.changeImage(nextIndex);
      });

      surface.addEventListener("pointercancel", () => {
        gesture = null;
      });

      surface.addEventListener("lostpointercapture", () => {
        gesture = null;
      });
    }

    attachEvents() {
      this.thumbnails.forEach((thumb, i) => {
        thumb.addEventListener("click", () => this.changeImage(i));
      });

      this.dots.forEach((dot, i) => {
        dot.addEventListener("click", () => this.changeImage(i));
        dot.addEventListener("keydown", (event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            this.changeImage(i);
          }
        });
      });

      const bindArrow = (arrow, direction) => {
        if (!arrow) return;

        const navigate = () => {
          if (!this.mainImages.length) return;

          const index =
            (this.currentIndex + direction + this.mainImages.length) %
            this.mainImages.length;

          this.changeImage(index);
        };

        arrow.addEventListener("click", navigate);
        arrow.addEventListener("keydown", (event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            navigate();
          }
        });
      };

      bindArrow(this.desktopPrevArrow, -1);
      bindArrow(this.desktopNextArrow, 1);

      this.mobilePrevArrows.forEach((arrow) => bindArrow(arrow, -1));
      this.mobileNextArrows.forEach((arrow) => bindArrow(arrow, 1));

      if (this.indicatorsContainer) {
        this.indicatorsContainer.addEventListener("click", (event) => {
          if (event.target.classList.contains("shop-indicator-dot")) {
            const index = parseInt(
              event.target.getAttribute("data-index"),
              10
            );

            if (!Number.isNaN(index)) this.changeImage(index);
          }
        });
      }
    }

    createIndicators() {
      if (!this.indicatorsContainer) return;

      this.indicatorsContainer.innerHTML = "";

      this.mainImages.forEach((_, i) => {
        const dot = document.createElement("div");
        dot.className = "shop-indicator-dot" + (i === 0 ? " active" : "");
        dot.setAttribute("data-index", i);
        this.indicatorsContainer.appendChild(dot);
      });
    }

    changeImage(index) {
      if (index < 0 || index > this.maxIndex) return;

      this.mainImages.forEach((img, i) => {
        img.classList.toggle("active", i === index);
      });
      this.thumbnails.forEach((thumb, i) => {
        thumb.classList.toggle("active", i === index);
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle("active", i === index);
      });

      if (this.indicatorsContainer) {
        Array.from(this.indicatorsContainer.children).forEach((dot, i) => {
          dot.classList.toggle("active", i === index);
        });
      }

      this.currentIndex = index;
      this.scrollToThumbnail(index);
      this.handleVideoAutoplay(index);
    }

    scrollToThumbnail(index) {
      const thumbnail = this.thumbnails[index];
      if (!thumbnail) return;

      const container = thumbnail.parentElement;
      if (!container) return;

      const scrollPosition =
        thumbnail.offsetLeft -
        container.offsetWidth / 2 +
        thumbnail.offsetWidth / 2;

      container.scrollTo({
        left: scrollPosition,
        behavior: "smooth"
      });
    }

    handleVideoAutoplay(index) {
      this.mainImages.forEach((media) => {
        const video = media.querySelector("video");

        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      });

      const activeMedia = this.mainImages[index];
      if (!activeMedia) return;

      const video = activeMedia.querySelector("video");

      if (video && enableAutoplay) {
        video.play().catch(() => {});
      }
    }

    updateWithVariant(variant) {
      let matchIndex = -1;

      if (
        variant &&
        (variant.mediaId || variant.variantId || variant.imageUrl)
      ) {
        this.mainImages.forEach((img, i) => {
          const matchesMedia =
            variant.mediaId && img.dataset.mediaId == variant.mediaId;

          const matchesVariant =
            variant.variantId &&
            img.dataset.variantId == variant.variantId;

          const matchesUrl =
            variant.imageUrl &&
            (
              (img.src && img.src.includes(variant.imageUrl)) ||
              (img.dataset.src &&
                img.dataset.src.includes(variant.imageUrl))
            );

          if (matchesMedia || matchesVariant || matchesUrl) {
            matchIndex = i;
          }
        });
      }

      this.changeImage(matchIndex >= 0 ? matchIndex : 0);
    }
  }

  const galleryRegistry = [];

  function initAll() {
    document.querySelectorAll(".product-gallery").forEach((container) => {
      if (!container.__galleryInstance) {
        const gallery = new ProductGallery(container);
        container.__galleryInstance = gallery;
        galleryRegistry.push(gallery);
      }
    });
  }

  function handleVariantEvent(event) {
    if (
      event.detail &&
      (
        event.detail.variantId ||
        event.detail.mediaId ||
        event.detail.imageUrl
      )
    ) {
      galleryRegistry.forEach((gallery) => {
        if (gallery.container.isConnected) {
          gallery.updateWithVariant(event.detail);
        }
      });
    }
  }

  document.addEventListener("variantImageSelected", handleVariantEvent);
  document.addEventListener("variant:imageChanged", handleVariantEvent);
  document.addEventListener("shopify:section:load", initAll);

  window.ProductGallery = {
    initAll,
    getAll: () => galleryRegistry
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();